import React, {useState} from 'react';
import {connect} from 'react-redux';
import {Button, Input, InputContainer} from 'finform';

import {handleCloseModal, handleForgotModal, login} from '#app/redux/actions/auth';
import {
    handleLoginFailure,
    handleLoginSuccess,
    initialLoginFormState,
    LoginFormInterface,
    SuccessCallbacksListInterface,
} from "#app/api/login";

import BaseFormContainer from './BaseFormContainer';

import {Container, HeaderForget, HeaderForgetContainer, Wrapper} from '../styles';
import {Row} from '#app/pages/styles';

interface LoginProps {
    title: string | undefined | null;
    login: (payload: any) => void;
    handleForgotModal: () => void;
    handleCloseModal: () => void;
    callback?: () => void;
}

const FormOnLogin: React.FC<LoginProps> = ({
                                               title = null,
                                               login,
                                               handleForgotModal,
                                               handleCloseModal,
                                               callback
                                           }) => {
    const [form, setForm] = useState<LoginFormInterface>(initialLoginFormState);
    const [type, setType] = useState<string>('');
    const [submitted, setSubmitted] = useState<boolean>(false);
    const [checked, setChecked] = useState<boolean>(false);

    const getError = (fieldName: string): string | null => {
        return null; // Обработчик ошибок из легаси
    };

    const handleInputChange = (field: string, value: string) => {
        setForm((prev) => ({...prev, [field]: value}));
    };

    const submitForm = () => {
        setSubmitted(true);
        const successCallbacks: SuccessCallbacksListInterface = { handleCloseModal, setForm, setSubmitted, callback };
        login({
            form,
            success: (response: any, status: number, xhr: any) => handleLoginSuccess(
                {response, status, xhr}, successCallbacks
            ),
            error: (xhr: any, responseData: any) => handleLoginFailure(type, responseData, setType, setSubmitted),
            obj: {state: form, setState: (stateUpdater: any) => setForm((prev) => stateUpdater(prev))},
        });
    };

    const handleCheckbox = () => setChecked((prev) => !prev);
    const handleEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' || e.keyCode === 13) {
            submitForm();
        }
    };

    return (
        <BaseFormContainer title={title} onSubmit={submitForm}>
            <Wrapper>
                <Container>
                    <Row>
                        <InputContainer error={getError('email')}>
                            <Input
                                id="login-email"
                                name="email"
                                onKeyDown={handleEnter}
                                autoComplete="on"
                                value={form.email}
                                onChange={(value) => handleInputChange('email', value)}
                                placeholder="Email"
                            />
                        </InputContainer>
                    </Row>
                    <Row>
                        <InputContainer error={getError('password')}>
                            <Input
                                id="login-password"
                                type="password"
                                name="password"
                                onKeyDown={handleEnter}
                                value={form.password}
                                onChange={(value) => handleInputChange('password', value)}
                                placeholder="Пароль"
                            />
                        </InputContainer>
                    </Row>
                    {type === '2fa' && (
                        <Row>
                            <InputContainer error={getError('code')}>
                                <Input
                                    id="login-code"
                                    type="text"
                                    name="code"
                                    value={form.code}
                                    onChange={(value) => handleInputChange('code', value)}
                                    placeholder="Код 2FA"
                                />
                            </InputContainer>
                        </Row>
                    )}
                    <Row>
                        <HeaderForgetContainer>
                            <HeaderForget
                                id="forgot-button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleForgotModal();
                                }}
                            >
                                Забыли пароль?
                            </HeaderForget>
                        </HeaderForgetContainer>
                    </Row>
                    <Row>
                        <Button wide id="login-submit" onClick={submitForm}>
                            Войти
                        </Button>
                    </Row>
                </Container>
            </Wrapper>
        </BaseFormContainer>
    );
};

const enhance = connect(
    (state: any) => ({}),
    {login, handleForgotModal, handleCloseModal}
);

export {FormOnLogin};
export default enhance(FormOnLogin);